import { useNavigate } from 'react-router-dom';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppContainer } from './App.styles';
import { Router } from './Router';
import { useEffect, useRef, useState } from 'react';
import Authentication from './Services/Authentication.service';
import { updatePlatform, configRetrievalFailed, retrievedAppState, updateDebug } from './redux/slices/App.slice';
import { useAppDispatch } from './redux/hooks';
import { removeTwitchListeners, startTwitchListeners } from './Helpers/Listeners';
import { IExtensionCommand } from './Types/command.types';
import { Platforms } from './Types/app.types';
import Layout from './Components/Layout/Layout';

export default function App() {
	const navigate = useNavigate();
	const authorizeTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
	const offlineScreenTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

	const [platform, setPlatform] = useState<Platforms>(Platforms.PANEL);
	const [isConfig, setIsConfig] = useState(false);
	const dispatch = useAppDispatch();

	useEffect(() => {
		const queryParams = globalThis?.location?.search;
		const type = queryParams?.match(/type=(\w+)/)?.[1];
		const platform = queryParams?.match(/platform=(\w+)/)?.[1];

		setIsConfig(type === 'config');

		if (platform) {
			setPlatform(platform as Platforms);
		}
		dispatch(updatePlatform(platform));

		const twitch = globalThis.Twitch ? globalThis.Twitch.ext : null; // If the extension is running on twitch or dev rig, set the shorthand here. otherwise, set to null.
		if (twitch) {
			twitch.onAuthorized((auth) => {
				clearTimeout(authorizeTimeoutRef.current!);
				Authentication.setToken(auth);
				setupConfig();
			});
			if (process.env.REACT_APP_BYPASS_AUTH) {
				authorizeTimeoutRef.current = setTimeout(() => dispatch(updateDebug(true)), 3000);
			}
			startTwitchListeners();
		} else {
			//TODO: make sure that this is the check that we want for streamer offline
			offlineScreenTimeoutRef.current = setTimeout(() => {
				navigate('/offline');
			}, 3000);
		}

		return () => {
			removeTwitchListeners();
			clearTimeout(authorizeTimeoutRef.current!);
		};
	}, []);

	// Called only on startup
	function setupConfig() {
		const twitch = globalThis.Twitch ? globalThis.Twitch.ext : null;

		// Get Bits
		twitch.bits.getProducts().then(function (products) {
			globalThis.Twitch.ext.rig.log('Bits products: ', products); // [ { sku: 'abc123', cost: { type: 'bits', amount: '10' } } ]
		});

		// Get Config
		Authentication.makeCall('api/extension/config')
			.then((configRes) => {
				const data: IExtensionCommand = configRes.data;
				dispatch(retrievedAppState(data));
			})
			.catch((err) => {
				console.error('Error getting configuration: ', err);

				if (isConfig) {
					navigate('/activate');
				} else {
					navigate('/offline');
				}
				dispatch(configRetrievalFailed(err.response));
				clearTimeout(offlineScreenTimeoutRef.current!);
				clearTimeout(authorizeTimeoutRef.current!);
			});
	}

	return (
		<Layout>
			<AppContainer platform={platform}>
				<ToastContainer theme="dark" autoClose={5000} pauseOnHover={false} position={'bottom-right'} transition={Bounce} closeButton={false} />
				<Router />
			</AppContainer>
		</Layout>
	);
}
